import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthProvider';
import "./assets/styles/index.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'simplebar/dist/simplebar.min.css';
import 'swiper/css';
import { ThemeProvider } from '@material-tailwind/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ScrollToTop from 'components/utils/ScrollToTop';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'leaflet/dist/leaflet.css';

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <ScrollToTop>
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </ScrollToTop>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);


